<div class="home__carouselstep__container">
  <div class="carousel__content">
    <div class="carousel__image__left">
      <ng-container *ngFor="let step of steps; let i = index">
        <img
          *ngIf="i === currentIndex"
          [@fadeSlideAnimation]
          [src]="step.img"
          [alt]="step.titleKey | translate"
          loading="lazy"
          decoding="async"
        />
      </ng-container>
    </div>

    <div class="carousel__content__right">
      <h2 [@fadeSlideAnimation] [innerHTML]="'home.steps.main_title' | translate"></h2>

      <div class="carousel__steps-nav">
        <button
          class="carousel__step-btn"
          *ngFor="let step of steps; let i = index"
          [class.active]="i === currentIndex"
          (click)="showSlide(i)"
        >
          {{ i + 1 }}
        </button>
      </div>

      <h3
        class="carousel__slide-title"
        *ngIf="steps[currentIndex]"
        [@fadeSlideAnimation]
      >
        {{ steps[currentIndex].titleKey | translate }}
      </h3>

      <p
        class="carousel__slide-desc"
        *ngIf="steps[currentIndex]"
        [@fadeSlideAnimation]
      >
        {{ steps[currentIndex].descKey | translate }}
      </p>

        <button
                class="carousel__action-btn"
                [@fadeSlideAnimation]
                routerLink="/product"
                [queryParams]="{ personalize: true }"
        >
        {{ 'home.steps.action_btn' | translate }}
        </button>
    </div>
  </div>
</div>